import ConfigurationLayout from "./ConfigurationLayout";
export default ConfigurationLayout;
